import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AboutUs from "@/components/AboutUs";
import ProductCategories from "@/components/ProductCategories";
import CalendarioSemineSection from "@/components/CalendarioSemineSection";
import Brands from "@/components/Brands";
import WhyChooseUs from "@/components/WhyChooseUs";
import Gallery from "@/components/Gallery";
// import Testimonials from "@/components/Testimonials";
import PracticalInfo from "@/components/PracticalInfo";
import ContactSection from "@/components/ContactSection";
import ContactFormSection from "@/components/ContactFormSection";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";
import SEO from "@/components/SEO";
import StructuredData from "@/components/StructuredData";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";

const Index = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Mangimi Rubini",
    "description": "Mangimi per animali domestici e da allevamento, pellet, sementi, concimi e terricci dal 1983",
    "url": "https://www.rubinimagione.it",
    "telephone": "+39-075-8409633",
    "email": "info@mangimirubini.it",
    "foundingDate": "1983",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Via della Vittoria, 56",
      "addressLocality": "Magione",
      "addressRegion": "PG",
      "postalCode": "06063",
      "addressCountry": "IT"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "43.1389",
      "longitude": "12.2069"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:30",
        "closes": "12:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "15:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "08:30",
        "closes": "12:30"
      }
    ],
    "priceRange": "€€",
    "image": "https://www.rubinimagione.it/og-image.jpg",
    "logo": "https://storage.googleapis.com/gpt-engineer-file-uploads/vKF35DqI1Hg2grRJayX0Y6LHbkh1/uploads/1763051793894-favicon-32x32.png",
    "sameAs": [
      "https://www.facebook.com/mangimirubini"
    ]
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="Mangimi, Pet Food, Pellet e Sementi a Magione (PG)"
        description="Mangimi Rubini dal 1983: mangimi per animali domestici e da allevamento, pellet certificato A1, sementi, concimi e terricci a Magione, zona Trasimeno."
        keywords="mangimi magione, pet food trasimeno, pellet magione, crocchette cani perugia, mangimi allevamento umbria, concimi magione, sementi perugia"
        canonical="/"
      />
      <StructuredData data={localBusinessSchema} />
      <BreadcrumbSchema items={[{ name: "Home", url: "/" }]} />
      <Navbar />
      <Hero />
      <AboutUs />
      <ProductCategories />
      <CalendarioSemineSection />
      <Brands />
      <WhyChooseUs />
      <Gallery />
      {/* <Testimonials /> */}
      <PracticalInfo />
      <ContactSection />
      <ContactFormSection />
      <Footer />
      <ChatBot />
    </div>
  );
};

export default Index;
